<template>
    <div>
        <comp-title-dc back-url-name="home">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">我的账户</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/home', query: { tab: 'combination' } }">
                    组合投资
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="assets-detail">
            <div class="assets-title">持仓详情</div>
            <div class="assets-row">
                <div class="title-line"></div>
                <span class="title-content">资产分布</span>
            </div>
            <div class="assets-info">
                <div ref="assets-chart" class="assets-chart"></div>
                <div class="assets-type">
                    <div v-for="(item, index) in options.series" :key="index" class="type-item">
                        <div class="icon" :style="{ background: item.color }"></div>
                        <span class="text">{{ item.type }}</span>
                        <span class="rate">{{ item.rate }}</span>
                    </div>
                </div>
            </div>
            <div class="assets-row">
                <div class="title-line"></div>
                <span class="title-content">最近调仓</span>
                <el-select v-model="selectDate" style="margin-left: auto">
                    <el-option v-for="date in dateList" :key="date" :label="date" :value="date" />
                </el-select>
            </div>
            <div class="transfer-item">
                本期调仓说明：天弘互联网和广发小盘持有半导体、芯片的仓位较重，受中美贸易战和华为供应链的影响，短期会有调整压力，增加医疗创新占比。
            </div>
            <div v-for="(item, index) in transferList" :key="index" class="transfer-item">
                <div class="transfer-left">
                    <span class="business-type" :class="item.type == '1' ? 'buy' : 'sell'">
                        {{ item.type == "1" ? "买" : "卖" }}
                    </span>
                    <span class="fund-name">{{ item.name }}</span>
                </div>
                <div class="transfer-right">
                    <span>{{ item.from }}</span>
                    <img src="@/assets/img/transfer-ic.png" alt="" />
                    <span class="to">{{ item.to }}</span>
                </div>
            </div>
            <div style="height: 20px"></div>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import format from "date-fns/format";
import fundApi from "@/api/fund";
import echarts from "echarts/index.common";

export default {
    name: "AssetsDetail",
    components: {},
    mixins: [mixin],
    data() {
        return {
            assetsInfo: {}, // 持仓信息
            lineArt: null,
            options: {},
            selectDate: "",
            dateList: ["2021-06-07", "2021-06-08", "2021-06-09", "2021-06-10", "2021-06-11"],
            transferList: [
                {
                    type: "1",
                    name: "中欧医疗创新股票A",
                    from: "85.46%",
                    to: "70.00%"
                },
                {
                    type: "2",
                    name: "前海开源中国稀有资产混合A",
                    from: "8.35%",
                    to: "0.00%"
                }
            ]
        };
    },
    beforeDestroy() {
        if (this.lineArt) this.lineArt.clear();
    },
    mounted() {
        this.assetsInfo = this.$store.state.user.currentAsset;
        this.options = {
            series: [
                {
                    color: "#FF7D00",
                    type: "混合型",
                    rate: "61.2%"
                },
                {
                    color: "#007AFF",
                    type: "股票型",
                    rate: "38.8%"
                }
            ]
        };
        this.initChart();
    },
    methods: {
        // 赋值收益数据
        assignProfitData() {
            let array = [];
            const item1 = {
                text: this.assetsInfo.profitdate
                    ? `${format(this.assetsInfo.profitdate, "MM-DD")}收益(元)`
                    : "收益(元)",
                oldVal: this.assetsInfo.lastprofit,
                val: this.$util.fmtNum(this.assetsInfo.lastprofit)
            };
            const item2 = {
                text: "持仓收益(元)",
                oldVal: this.assetsInfo.currentprofit,
                val: this.$util.fmtNum(this.assetsInfo.currentprofit)
            };
            array.push(item1, item2);
            if (this.assetsInfo.fundshowtype == "5") {
                // 货币基金
                const item3 = {
                    text: "万份收益",
                    oldVal: this.assetsInfo.fundincomeunit,
                    val: this.$util.fmtNum(this.assetsInfo.fundincomeunit, 4)
                };
                const item4 = {
                    text: "七日年化收益率",
                    oldVal: this.assetsInfo.growthrate,
                    val: this.formatterRate(this.assetsInfo.growthrate)
                };
                array.push(item3, item4);
            } else {
                // 非货币基金
                const item3 = {
                    text: this.assetsInfo.navdate
                        ? `最新净值(${this.$util.fmtDate(this.assetsInfo.navdate)})`
                        : "最新净值",
                    oldVal: this.assetsInfo.nav,
                    val: this.$util.fmtNum(this.assetsInfo.nav, 4)
                };
                const item4 = {
                    text: "日涨幅",
                    oldVal: this.assetsInfo.dayfloatprofit,
                    val: this.formatterRate(this.assetsInfo.dayfloatprofit)
                };
                array.push(item3, item4);
            }
            this.profits = array;
        },
        // 格式化涨跌幅数据
        formatterRate(rate) {
            if (!rate) {
                return "--";
            }
            return this.$util.fmtNum(rate) + "%";
        },
        // 开始绘制图表
        initChart() {
            this.lineArt = echarts.init(this.$refs["assets-chart"]);
            let _x = {
                color: this.options.color || ["#007AFF", "#FF7D00", "#ea2600"],
                grid: {
                    left: "2%",
                    right: "4%",
                    bottom: "3%",
                    top: "20px",
                    containLabel: true
                },
                series: [
                    {
                        type: "pie",
                        silent: true,
                        label: {
                            show: false
                        },
                        data: [
                            {
                                value: 388,
                                name: "A"
                            },
                            {
                                value: 612,
                                name: "B"
                            }
                        ],
                        radius: ["40%", "70%"]
                    }
                ]
            };
            // 把配置和数据放这里
            this.lineArt.setOption(_x);
            this.resizeChart();
        },
        // 图表变化重绘
        resizeChart() {
            const _this = this;
            window.addEventListener("resize", () => {
                if (_this.lineArt) _this.lineArt.resize();
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "../../assets/css/varibles";
.assets-detail {
    margin-top: 10px;
    box-sizing: border-box;
    border: 1px solid #f1f1f1;
    .assets-title {
        padding: 20px 0 25px 16px;
        font-size: 20px;
        font-weight: 500;
        color: #333333;
        border-bottom: 1px solid #f1f1f1;
    }
    .assets-info {
        display: flex;
        align-items: center;
        .assets-chart {
            width: 320px;
            height: 320px;
        }
        .assets-type {
            display: flex;
            flex-direction: column;
            gap: 20px;
            .type-item {
                display: flex;
                align-items: center;
                .icon {
                    width: 18px;
                    height: 18px;
                    border-radius: 2px;
                }
                .text {
                    margin-left: 5px;
                    font-size: 16px;
                    color: #999999;
                }
                .rate {
                    margin-left: 25px;
                    font-size: 16px;
                    font-weight: bold;
                    color: #333333;
                }
            }
        }
    }
    .assets-row {
        margin: 20px 20px 0 20px;
        display: flex;
        align-items: center;
        padding: 0 16px;
        height: 60px;
        border-radius: 2px 2px 0px 0px;
        background: #f9f9f9;
        box-sizing: border-box;
        border: 1px solid #f1f1f1;
    }
    .transfer-item {
        border: 1px solid #f1f1f1;
        border-top: none;
        font-size: 14px;
        color: #666666;
        padding: 16px;
        margin: 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .transfer-left {
            display: flex;
            align-items: center;
            .business-type {
                width: 24px;
                height: 24px;
                border-radius: 4px;
                text-align: center;
                line-height: 24px;
                font-size: 14px;
            }
            .buy {
                background: #ffecec;
                color: #e60012;
            }
            .sell {
                background: #edf7ff;
                color: #1890ff;
            }
            .fund-name {
                margin-left: 11px;
                font-size: 16px;
                font-weight: 500;
                color: #333333;
            }
        }
        .transfer-right {
            display: flex;
            align-items: center;
            gap: 20px;
            font-size: 18px;
            font-weight: bold;
            color: #666666;
            .to {
                color: #333333;
                min-width: 70px;
                text-align: right;
            }
        }
    }
}
</style>
